import script from "./ResearchGroupCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResearchGroupCard.vue?vue&type=script&setup=true&lang=ts"

import "./ResearchGroupCard.vue?vue&type=style&index=0&id=63d05856&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d05856"]])

export default __exports__